import React from 'react'

import { updateDrCalculatorStart } from '@sm360/helpers'

import { Context } from '../../../configs/state.manager'

import { getQuoteDeskingPaymentOptions } from '../../../apis/showroom/showroom.service'

import { payloadPaymentOptionsTransform } from '../../../transforms/payloadPaymentOptions.transform'

import TermsTable from '../../common/terms/terms-table/TermsTable'

const LeaseTerms = () => {
    const {
        state,
        state: {
            paymentOptions: { cashDown: cashDownSelected, financeOptions },
            quoteId,
            vehicle,
        },
        dispatch,
    } = React.useContext(Context)

    if (!financeOptions || !financeOptions.length) return null

    const { cashDownOptions, selectedPayment, paymentFrequency } = financeOptions.find(
        ({ purchaseMethod }) => purchaseMethod === 'lease'
    )

    if (!cashDownOptions || !cashDownOptions.length) return null

    const { terms } = cashDownOptions.find(({ cashDown }) => cashDownSelected === cashDown) || cashDownOptions[0]

    const handleClick = async (term) => {
        try {
            const payload = payloadPaymentOptionsTransform({ state, term })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payload)

            updateDrCalculatorStart(quoteId, vehicle, 'lease')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className='pc-leaseTerms'>
            <TermsTable
                terms={terms}
                selectedPayment={selectedPayment}
                paymentFrequency={paymentFrequency}
                onClick={handleClick}
            />
        </div>
    )
}

export default LeaseTerms
